import React, { useState, forwardRef } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import styles from './FormInput.module.scss'
import FormattedMessage from '../../helpers/FormattedMessage'

interface IProps {
  title: string
  onChange: any
  value: any
}

export const FormDate = ({
  title,
  value,
  onChange,
}: IProps) => {
  const [state, setState] = useState(value)

  const onDateChange = (date: any) => {
    setState(date)
    onChange(date)
  }

  const ExampleCustomInput = forwardRef(({ value, onClick }: { value?: any, onClick?: any }, ref: any) => (
    <button className="example-custom-input" onClick={onClick} ref={ref}>
      {value}
    </button>
  ))

  return (
    <div className={styles.Wrapper}>
      <div className={styles.FormItem}>
        <div className={styles.InfoContainer}>
          <h4 className={styles.Title}>
            <FormattedMessage id={title} />
          </h4>
          <DatePicker
            dateFormat="dd/MM/yyyy"
            selected={state}
            onChange={(date: Date | [Date | null, Date | null] | null) => onDateChange(date)}
            customInput={<ExampleCustomInput value={null} onClick={null} />}
          />
        </div>
      </div>
    </div>
  )
}
